import { useState } from "react";
import { FiArrowLeft, FiCamera, FiEdit3, FiTruck } from "react-icons/fi";
import { BsWhatsapp } from "react-icons/bs";
import SpecialOrderModal from "./specialOrderModal";
import styles from "../styles/designCta.module.css";

const WA_LINK = "https://wa.me/972543255575";

const STEPS = [
  { icon: <FiCamera />, text: "أرسل صورة حائطك" },
  { icon: <FiEdit3 />, text: "نصمم فكرتك" },
  { icon: <FiTruck />, text: "نطبع ونوصل" },
];

// "Didn't find your painting? Design your own" — call to action shown after the
// product list; opens the custom-design (special order) modal.
const DesignYourOwnCta = () => {
  const [open, setOpen] = useState(false);

  return (
    <section className={styles.cta} aria-labelledby="design-cta-title">
      <div className={styles.frame} aria-hidden="true" />

      <div className={styles.body}>
        <span className={styles.eyebrow}>
          <span className={styles.eyebrowStar}>✦</span>
          تصميم حسب الطلب
        </span>

        <h2 id="design-cta-title" className={styles.title}>لم تجد لوحتك بعد؟</h2>
        <p className={styles.subtitle}>صمم لوحتك الخاصة</p>

        <p className={styles.text}>
          شاركنا فكرتك أو صورة حائطك، وسنصمم لك لوحة فريدة تناسب ذوقك ومساحتك — قطعة لا تشبه أي لوحة أخرى.
        </p>

        <ol className={styles.steps}>
          {STEPS.map((step, i) => (
            <li key={step.text} className={styles.step}>
              <span className={styles.stepIcon}>{step.icon}</span>
              <span className={styles.stepText}>{step.text}</span>
              {i < STEPS.length - 1 && <span className={styles.stepLine} aria-hidden="true" />}
            </li>
          ))}
        </ol>

        <div className={styles.actions}>
          <button type="button" className={styles.primary} onClick={() => setOpen(true)}>
            صمم لوحتك الخاصة
            <FiArrowLeft className={styles.primaryIcon} />
          </button>
          <a href={WA_LINK} target="_blank" rel="noreferrer" className={styles.secondary}>
            <BsWhatsapp />
            تحدث معنا
          </a>
        </div>
      </div>

      <div className={styles.art} aria-hidden="true">
        <div className={`${styles.canvas} ${styles.canvasBack}`}>
          <span className={styles.calligraphy}>فَذَكِّرْ</span>
        </div>
        <div className={`${styles.canvas} ${styles.canvasFront}`}>
          <span className={styles.calligraphy}>لوحتك<br />بتوقيعك</span>
          <span className={styles.shine} />
        </div>
        <span className={`${styles.sparkle} ${styles.sparkleA}`}>✦</span>
        <span className={`${styles.sparkle} ${styles.sparkleB}`}>✦</span>
      </div>

      <SpecialOrderModal isOpen={open} onClose={() => setOpen(false)} />
    </section>
  );
};

export default DesignYourOwnCta;
